import { connect } from 'react-redux';
/**
 * TODO: Вынести компоненты с визой вниз на страницу Package, чтобы использовать их тут
 * Либо пошарить часть стора, связанную с визами между страницами
 * @see https://leveltravel.atlassian.net/browse/LT-25906
 */

import { getTourId } from 'src/routes/Checkout/store/selectors/package';
import {
  getServiceName,
  getServicePrice,
  getVisaRulesLink,
  VISA_SERVICES,
} from '../../routes/Checkout/store/domains/visa';

import VisaServiceLabel from '../../routes/Checkout/components/Tourists/VisaServiceLabel';

const mapStateToProps = (state, { serviceItem }) => {
  const visaRulesLink = getVisaRulesLink(state);

  const tourId = getTourId(state);

  const { id, label } = serviceItem;
  const servicePrice = getServicePrice(state, id, tourId);
  const serviceName = getServiceName(state, id, label, tourId);

  return {
    label: serviceName,
    price: servicePrice,
    visaRulesLink: id === VISA_SERVICES.VISA_FULL.id ? visaRulesLink : null,
  };
};

export default connect(mapStateToProps)(VisaServiceLabel);
